import React from 'react';
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
//import IconButton from '@material-ui/core/IconButton';
//import MoreVertIcon from '@material-ui/icons/MoreVert';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import EmailIcon from '@material-ui/icons/Email';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import { TextField, Divider } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

import PropTypes from 'prop-types';
import UserInfoLoader from './UserInfoLoader';

const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1,
    },
    root2: {
      backgroundColor: theme.palette.background.paper,
      width: 500,
      position: 'relative',
      minHeight: 300,
    },
    paper: {
      height: 500,
      width: 400,
    },
    control: {
      padding: theme.spacing(2),
    },
    card: {
        height: 500,
        width: 400,
        maxWidth: 345,
      },
    card2: {
      height: 100,
      width: 100,
      maxWidth: 345,
    },
      media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
      },
      expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
      },
      expandOpen: {
        transform: 'rotate(180deg)',
      },
      avatar: {
        backgroundColor: 'rgb(0, 160, 175)',
      },
      fab: {
        position: 'absolute',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
      },
      rowIcon: {
        top: '40%'
      },
      titleDark: {
        color: 'rgb(0, 0, 1)',
        fontWeight: 'bold',
        fontSize: '0.875rem'
      },
      titleLight: {
        color: 'rgb(0, 0, 1)',
        fontSize: '0.875rem'
      },
      titleGreenBlackPrimary: {
        color: 'rgb(0, 160, 175)',
        fontWeight: 'bold',
        fontSize: '1.05rem'
      },
      titleGreenBlackSecondary: {
        color: 'rgb(0, 160, 175)',
        fontWeight: 'bold',
        fontSize: '1rem'
      }
  }));
const UserPanelInfo = props => {
    const classes = useStyles();
    const {  user, balances, accountSelected, changeAccount} = props
    // const { owner, name, number, accname } = userSelected
    return (
      user ?
      <Grid  item xs={12} md={6} lg ={6} >
        <Card className={classes.card}>
        <CardHeader
          avatar={
          <Avatar aria-label="recipe" className={classes.avatar}>
            {user.Nombres.charAt(0) }
          </Avatar>
          }
          
          title={ <span className = {classes.titleDark}>{ (user.EsPersonaNatural === true) ? `${user.Nombres} ${user.Apellidos} ` : user.RazonSocial }  </span> }
          subheader={ <span className = {classes.titleLight}> {  `${accountSelected.Tipo} - ${accountSelected.Codigo}` } </span> }
          />
          <Divider></Divider>
          <br></br>
            <Autocomplete className = {classes.root}
              id="combo-box-demo"
              
              value = { accountSelected }
              options={balances}
              onChange = { (e, nv) => {
                  changeAccount(nv)
              }}
              disableClearable
              getOptionLabel={ (option) =>  `${option.Tipo} - ${option.Codigo}` }
              renderOption={(option) => (
              <React.Fragment>
                  {`${option.Tipo} - ${option.Codigo}`}
              </React.Fragment>
              )}
              renderInput={(params) => <TextField {...params} label="Seleccione una cuenta"  variant="outlined" fullWidth/>}
            />
            <br></br>
            <Divider></Divider>
          <CardContent>
            <List className={classes.root}>
                <ListItem button>
                    <ListItemAvatar>
                    <Avatar>
                      <LocalAtmIcon />
                    </Avatar>
                    </ListItemAvatar>
                        <ListItemText
                            primary={
                              <span className = { classes.titleGreenBlackPrimary}>
                                  Saldo Disponible
                              </span>
                            }
                            secondary={
                              <span className = { classes.titleGreenBlackSecondary}>
                                  {`$ ${accountSelected.SaldoCuenta}`}
                              </span>
                            } />
                </ListItem>
                <ListItem button>
                    <ListItemAvatar>
                    <Avatar>
                      <EmailIcon />
                    </Avatar>
                    </ListItemAvatar>
                      <ListItemText
                          primary={
                            <span className = {classes.titleDark}>
                                Correo Electrónico
                            </span>
                          }
                          secondary={ 
                            <span className = {classes.titleLight}>
                                { user.CorreoElectronico }
                            </span>
                          } />
                </ListItem>
            </List>
          </CardContent>
        </Card>
      </Grid>:
      <UserInfoLoader classes = {classes} />
    );
};

UserPanelInfo.propTypes = {
    user: PropTypes.object.isRequired,
    balances: PropTypes.array.isRequired,
    accountSelected: PropTypes.object.isRequired,
    changeAccount: PropTypes.func.isRequired,
};

export default UserPanelInfo;